import * as React from 'react';
import classNames from 'classnames';

import {
  CheckmarkLargeIcon,
  CircleXIcon,
  CircleInformationIcon,
  CircleWarningIcon,
  ScienceIcon,
} from '../Icon/generated/index';
import {Text, TextColors, TextVariant} from '../Text/Text.web';

import styles from './HelpMessage.module.css';

export enum HelpMessageTypes {
  WARNING = 'warn',
  INFO = 'info',
  ERROR = 'danger',
  POSITIVE = 'positive',
  PREVIEW = 'preview',
}

interface HelpMessageProps {
  children: React.ReactNode;
  messageType: HelpMessageTypes;
  className?: string;
  textColor?: TextColors;
  textVariant?: TextVariant;
}

function getIcon(messageType: HelpMessageTypes) {
  switch (messageType) {
    case HelpMessageTypes.WARNING:
      return CircleWarningIcon;
    case HelpMessageTypes.INFO:
      return CircleInformationIcon;
    case HelpMessageTypes.ERROR:
      return CircleXIcon;
    case HelpMessageTypes.POSITIVE:
      return CheckmarkLargeIcon;
    case HelpMessageTypes.PREVIEW:
      return ScienceIcon;
  }
}

function getStyle(messageType: HelpMessageTypes) {
  switch (messageType) {
    case HelpMessageTypes.WARNING:
      return styles.warning;
    case HelpMessageTypes.INFO:
      return styles.info;
    case HelpMessageTypes.ERROR:
      return styles.error;
    case HelpMessageTypes.POSITIVE:
      return styles.positive;
    case HelpMessageTypes.PREVIEW:
      return styles.positive;
  }
}

export function HelpMessage({
  children,
  messageType,
  className,
  textColor = 'text-normal',
  textVariant = 'text-sm/medium',
}: HelpMessageProps) {
  const IconComponent = getIcon(messageType);
  const messageStyle = getStyle(messageType);
  return (
    <div className={classNames(styles.container, messageStyle, className)}>
      <div className={styles.iconDiv}>
        {IconComponent && <IconComponent className={styles.icon} color="currentColor" />}
      </div>
      <Text className={styles.text} color={textColor} variant={textVariant}>
        {children}
      </Text>
    </div>
  );
}
